import { render, staticRenderFns } from "./addRankCommissions.vue?vue&type=template&id=1fe551dd&scoped=true"
import script from "./addRankCommissions.vue?vue&type=script&lang=js"
export * from "./addRankCommissions.vue?vue&type=script&lang=js"
import style0 from "./addRankCommissions.vue?vue&type=style&index=0&id=1fe551dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe551dd",
  null
  
)

export default component.exports